import { useState, useEffect } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row"; // Import Row
import Form from "react-bootstrap/Form";
import "./calendar.css";

const venue = [null, "Kamla Nagar", "Adarsh Nagar"];


const Calendar = ({ data, onInputChange, value = {}, show }) => {
  const { name, options } = data;
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(value.date || "");

  useEffect(() => {
    if (!Array.isArray(options)) return;

    const uniqueDates = [
      ...new Set(
        options
          .filter((o) => o.clinic === venue[show])
          .map((o) => o.date)
      ),
    ];

    setDates(uniqueDates);
  }, [options, show]);

  const availableSlots = options?.filter(
    (o) => o.date === selectedDate && o.clinic === venue[show]
  );

  return (
    <Col md>
      {/* Added Row to hold both inputs side-by-side */}
      <Row>
        {/* STEP 1: DATE (Takes up half the space) */}
        <Col xs={6}>
          <Form.Group className="mb-3">
            <Form.Label>Select Date</Form.Label>
            <Form.Select
              value={selectedDate}
              onChange={(e) => {
                setSelectedDate(e.target.value);
                onInputChange(name, {
                  date: e.target.value,
                  time: "",
                  clinic: venue[show],
                });
              }}
            >
              <option value="">-- Select Date --</option>
              {dates.map((date, i) => (
                <option key={i} value={date}>
                  {date}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        {/* STEP 2: TIME (Takes up the other half) */}
        <Col xs={6}>
          <Form.Group className="mb-3">
            <Form.Label>Select Time</Form.Label>
            <Form.Select
              disabled={!selectedDate}
              value={value.time || ""}
              onChange={(e) =>
                onInputChange(name, {
                  date: selectedDate,
                  clinic: venue[show],
                  time: e.target.value,
                })
              }
            >
              <option value="">
                {selectedDate ? "-- Select Time --" : "Select date first"}
              </option>

              {availableSlots?.map((slot, i) => (
                <option key={i} value={slot.time} disabled={slot.booked}>
                  {slot.time} {slot.booked ? "(Booked)" : ""}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
    </Col>
  );
};

export default Calendar;
